import React from 'react';
import Ionicon from "react-ionicons";

export const PostErrorMessage = (props) => {
    const {onClose, error} = props;
        if (! error ) return null;
        return (
            <div className="popup-default">
                <div className="popup-inner">
                    <div className="popup-content">
                        <button className="close-popup" type="button" onClick={ () => onClose ()}>
                            <Ionicon icon="ion-close"/>
                        </button>
                        <h2 classname="h2">There has been an error and we could not complete your request.</h2>
                        <p className="p-tag">Error Code: <b>{error}</b></p>
                        <p className="p-tag">Please try again and if the problem persists contact Customer Care on 0161&nbsp;714&nbsp;84&nbsp;95 quoting error code {error}.</p>
                        <ul className="buttons-left">
                            <li>
                                <button className="btn btn-primary" type="button"
                                        onClick={ () => onClose() }>
                                    <span className="label">Close</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        )
};




// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/ui/PostErrorMessage.js